import CampaignNoteAdapter from 'cio/adapters/campaign-note';
import { unixNowSeconds } from 'cio/utils/time';
import DS, { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';
import { resolve } from 'rsvp';

const DEMO_USER = {
  id: 'demo',
  first_name: 'Demo',
  last_name: '',
  email: 'demo@customer.io',
};

// Override the CampaignNote adapter so that no real API requests are issued
export default class DemoCampaignNoteAdapter extends CampaignNoteAdapter {
  query(store: DS.Store) {
    return resolve({ notes: store.peekAll('campaign-note').toArray() });
  }

  createRecord(store: DS.Store, _type: ModelSchema<keyof ModelRegistry>, snapshot: DS.Snapshot<keyof ModelRegistry>) {
    // serializerFor has incorrect types, so we cast to any
    let note = (store.serializerFor as any)('campaign-note').serialize(snapshot);
    note.id = window.UUID.generate();
    let now = unixNowSeconds();
    note.created_at = now;
    note.updated_at = now;
    note.created_by = { ...DEMO_USER };
    note.updated_by = { ...DEMO_USER };
    return resolve({
      note,
    });
  }

  updateRecord(store: DS.Store, _type: ModelSchema<keyof ModelRegistry>, snapshot: DS.Snapshot<keyof ModelRegistry>) {
    // serializerFor has incorrect types, so we cast to any
    let note = (store.serializerFor as any)('campaign-note').serialize(snapshot, { includeId: true });
    let now = unixNowSeconds();
    note.created_at = now;
    note.updated_at = now;
    return resolve({
      note,
    });
  }

  deleteRecord() {
    return resolve();
  }
}
